import { Box, Typography, Stack, Button, TextField, MenuItem, Backdrop, LinearProgress } from "@mui/material";
import CompteItem from "../ui/compteItem";
import React, {useState} from "react";
import { API } from "../../conf";
import { Context } from "../../App";


export default function Virement({eglise, comptes, updateComptes, close}) {
    const {exercice} = React.useContext(Context)
    const [load, setLoad] = useState(false);
    const [msg, setMsg] = useState('');
    const [selectedCompte1, setSelectedCompte1] = useState('');
    const [selectedCompte2, setSelectedCompte2] = useState('');
    const [montant, setMontant] = useState((0).toFixed(2));
    const [motif, setMotif] = useState('');
    
    async function handleSubmit(event){
        event.preventDefault();
        setLoad(true);
        const montantValue = Math.round(parseFloat(montant) * 100) / 100;
        if(isNaN(montantValue) || montantValue<=0){
            alert('Veuillez entrer un montant valide');
            setLoad(false);
            return;
        }
        
        fetch(API+'/virement', {
            method:'POST',
            headers:{
                'Content-Type':'application/json',
                'Authorization': 'Bearer '+sessionStorage.getItem('token')
            },
            body: JSON.stringify({
                montant: montantValue,
                debit_compte: selectedCompte1,
                credit_compte: selectedCompte2,
                motif,
                eglise: eglise.number,
                exercice
            })
        })
        .then(async res=>{
            const token = res.headers.get('x-auth-token');
            if(token) sessionStorage.setItem('token', token);
            if(!res.ok){
                const text = await res.text();
                setMsg(text || 'Une erreur est survenue lors du virement');
            } else {
                const data = await res.json();
                updateComptes(data);
                close();
            }
        }).catch(err=>{
            console.error(err);
            setMsg('Une erreur est survenue lors du virement');
        }).finally(()=>{
            setLoad(false);
        })
    }

    return (
        eglise && comptes && <Box component={'form'} onSubmit={handleSubmit} sx={{display:'flex', flexDirection:'column', gap:2, px:3, py:2}}>
            <Typography variant='h3' color="primary" textAlign={'center'} textTransform={'uppercase'} fontWeight={600} mt={2}>Transfert de fonds</Typography>
            <Typography variant='subtitle1' textAlign={'center'} mt={-2} mb={2}>Effectuer un virement entre deux comptes de votre église</Typography>
            
            {msg && <Typography variant="h6" fontWeight={600} color='error' textAlign={'center'} mt={-2}>{msg}</Typography>}

            <Typography variant="h6">Je fais un virement de</Typography>
            <TextField variant="standard" type='number' required value={montant} 
            sx={{alignSelf:'center', width:'25%', minWidth:150}}
            inputProps={{step:'0.01', min:'0', style:{fontSize:'32px', textAlign:'center'}}}
            onFocus={()=> {if(Number(montant) === 0 || isNaN(Number(montant))) setMontant('')}}
            onBlur={()=> setMontant(previous => (!previous||previous === 0 ? 0 : Math.round(Number(previous)*100)/100).toFixed(2))}
            onChange={(e)=>setMontant(e.target.value=== '' ? '' : parseFloat(e.target.value))}
            />
            
            <Stack direction='column' spacing={2}>
                <TextField label='Compte source' select fullWidth required value={selectedCompte1}
                    onChange={(e)=>setSelectedCompte1(e.target.value)}
                >
                    {comptes.map(compte=>(
                        <MenuItem key={compte._id} value={compte.num}>
                            <CompteItem key={compte._id} compte={compte} />
                        </MenuItem>
                    ))}
                </TextField>
                <TextField label='Compte destination' select fullWidth required value={selectedCompte2}
                    onChange={(e)=>setSelectedCompte2(e.target.value)}
                >
                    {comptes.map(compte=>(
                        <MenuItem key={compte._id} value={compte.num}>
                            <CompteItem key={compte._id} compte={compte} />
                        </MenuItem>
                    ))}
                </TextField>
            </Stack>

            <TextField label='Motif' required fullWidth multiline rows={3} value={motif} onChange={(e)=>setMotif(e.target.value)} />

            <Stack direction='row' spacing={1} justifyContent='space-between'>
                <Button variant='text' sx={{fontWeight:'bold'}} onClick={close}>Annuler</Button>
                <Button disabled={montant <=0 || montant === '' } type='submit' variant='contained' color='primary'>Valider l'opération</Button>
            </Stack>

            <Backdrop open={load} sx={{zIndex: (theme) => theme.zIndex.drawer + 1, display:'flex', justifyContent:'center', alignItems:'center'}}>
                <LinearProgress color="primary" sx={{width:'80%', maxWidth:400, height:8, borderRadius:0.5}} />
            </Backdrop>
        </Box>
    )
}